Hop.defineModule('c-tabs', (root, param) => {
    const TAB_ITEM_CLASS = '.c-tabs_list__item';
    const isAutoplay = param.autoplay || false;
    const durationAutoplay = param.duration || 7000;

    const $tabs = root.querySelectorAll('[data-tab]');
    const $tabsSections = root.querySelectorAll('.c-tabs_section');
    const nbTabs = $tabsSections.length;

    let indexTabActive = 0;
    let timer = null;

    function init() {
        checkDOM();
        addListeners();

        if (isAutoplay && nbTabs > 1) {
            startAutoplay();
        }
    }

    function checkDOM() {
        if (!$tabs.length || !$tabsSections.length) {
            throw Error('You need to define some items for your list, or your tabs component has no section to show');
        }
    }

    function setTabActive(tab) {
        if (tab.target) {
            let $tab = tab.target;

            $tabs.forEach((tab) => tab.classList.remove('active'));

            if (!$tab.classList.contains(TAB_ITEM_CLASS) && !$tab.hasAttribute('data-tab')) {
                // Only because we put a span child in the data-tab item. Can be deleted when Malt Plus component will be migrated to design system one.
                $tab = tab.target.closest(TAB_ITEM_CLASS) || $tab.closest('[data-tab]');
            }

            $tab.classList.add('active');

            for (let i = 0; i < nbTabs; ++i) {
                if ($tabs[i].classList.contains('active')) {
                    indexTabActive = i;
                    break;
                }
            }

            showTabSection($tab);
            if (isAutoplay && nbTabs > 1) {
                resetAutoplay();
            }
        }
    }

    function showTabSection(tab) {
        const dataTab = tab.getAttribute('data-tab');
        const tabSection = Array.from($tabsSections).filter((section) => section.getAttribute('data-tab-section') === dataTab);

        $tabsSections.forEach((section) => section.classList.remove('active'));

        if (tabSection.length > 0) {
            tabSection.forEach((tab) => tab.classList.add('active'));
        }
    }

    function autoPlay() {
        if (indexTabActive + 1 === nbTabs) {
            indexTabActive = 0;
        } else {
            indexTabActive += 1;
        }

        $tabs[indexTabActive].dispatchEvent(new Event('click'));
    }

    function startAutoplay() {
        timer = setInterval(autoPlay, durationAutoplay);
    }

    function resetAutoplay() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
        startAutoplay();
    }

    function addListeners() {
        $tabs.forEach((tab) => {
            tab.addEventListener('click', setTabActive);
        });
    }

    function removeListeners() {
        $tabs.forEach((tab) => {
            tab.removeEventListener('click', setTabActive);
        });
    }

    init();

    return function destroy() {
        removeListeners();
        if (timer) {
            clearInterval(timer);
        }
    };
});
